<app-question-template [form]="form" [question]="question">
	@if (isV2()) {
		<div class="select-v2" [class.select-v2--list]="isSingleLineMode" [class.select-v2--grid]="!isSingleLineMode">
			@for (option of options; track option.selectQuestionOption.id) {
				<button
					type="button"
					class="select-v2-option"
					[class.select-v2-option--selected]="isOptionSelected(option.selectQuestionOption.id)"
					(click)="select(option.selectQuestionOption.id)"
				>
					@if (isOptionSelected(option.selectQuestionOption.id)) {
						<span
							class="material-symbols-outlined material-symbols-outlined--size-24 select-v2-option-icon"
							aria-hidden="true"
						>
							check
						</span>
					} @else if (option.showTrigger) {
						<span
							class="material-symbols-outlined material-symbols-outlined--size-24 select-v2-option-icon"
							aria-hidden="true"
						>
							assignment
						</span>
					}
					<span class="select-v2-option-label">{{ option.selectQuestionOption.translatedText }}</span>
				</button>
			}
		</div>
	} @else if (isSingleLineMode) {
		<!-- Show checkboxes if option lines are too long -->
		<ion-item *ngFor="let option of options" (click)="select(option.selectQuestionOption.id)">
			<ion-checkbox
				class="select-question"
				mode="ios"
				justify="start"
				labelPlacement="end"
				#checkboxRef
				[value]="option.selectQuestionOption.id"
				[checked]="answer?.answers?.includes(option.selectQuestionOption.id)"
			>
				<div class="checkbox-content">
					<ion-icon size="large" *ngIf="option.showTrigger" name="clipboard-outline"></ion-icon>
					<div class="option-text">{{ option.selectQuestionOption.translatedText }}</div>
				</div>
			</ion-checkbox>
		</ion-item>
	} @else {
		<!-- Otherwise show two buttons per row -->
		<ion-grid>
			<ion-row>
				<ion-col *ngFor="let option of options" size="6">
					<ion-button
						expand="block"
						shape="round"
						[color]="isOptionSelected(option.selectQuestionOption.id) ? 'primary' : 'light'"
						(click)="select(option.selectQuestionOption.id)"
					>
						{{ option.selectQuestionOption.translatedText }}
						<ion-icon slot="start" *ngIf="option.showTrigger" name="clipboard-outline"></ion-icon>
					</ion-button>
				</ion-col>
			</ion-row>
		</ion-grid>
	}
</app-question-template>
